import { vec3 } from "gl-matrix";

export const sortSeries = (instances) => {
   // Return if only one instance e.g., multiframe
    if (instances.length <= 1) {
      return instances;
    }
  
    const {
      imagePositionPatient: referenceImagePositionPatient,
      imageOrientationPatient,
    } = instances[Math.floor(instances.length / 2)].imagePlane; // this prevents getting scout image as test image
  
    if (!referenceImagePositionPatient || !imageOrientationPatient) {
      return instances;
    }
  
    const rowCosineVec = vec3.fromValues(
        imageOrientationPatient[0],
        imageOrientationPatient[1],
        imageOrientationPatient[2]
    );
    const colCosineVec = vec3.fromValues(
        imageOrientationPatient[3],
        imageOrientationPatient[4],
        imageOrientationPatient[5]
    );
  
    const scanAxisNormal = vec3.cross(vec3.create(), rowCosineVec, colCosineVec);
  
    const refIppVec = vec3.set(
      vec3.create(),
      referenceImagePositionPatient[0],
      referenceImagePositionPatient[1],
      referenceImagePositionPatient[2]
    );
  
    const distanceInstancePairs = instances.map(instance => {
      const imagePositionPatient = instance.imagePlane.imagePositionPatient;
  
      const positionVector = vec3.create();
  
      vec3.sub(
        positionVector,
        referenceImagePositionPatient,
        imagePositionPatient
      );
  
      const distance = vec3.dot(positionVector, scanAxisNormal);
  
      return {
        distance,
        instance,
      };
    });
  
    distanceInstancePairs.sort((a, b) => b.distance - a.distance);
  
    const sortedInstances = distanceInstancePairs.map(a => a.instance);
  
    return sortedInstances;
  }